export default "/by.5a1623aa-84bab7.png";